import { MAINNET_RELAY_API } from '@relayprotocol/relay-sdk'
import type { RelayAddress } from './execution'
import {
  convertFunToRelayChainId,
  convertFunToRelayTokenAddress,
  filterNullishHeaders,
} from './utils'

export interface RelayTokenInfo {
  chainId: number
  address: string
  symbol: string
  name: string
  decimals: number
  vmType: string
  metadata: {
    logoURI: string
    verified: boolean
    isNative: boolean
  }
}

interface GetRelayAssetInfoParams {
  chainId: string
  address: string
  useExternalSearch?: boolean
  apiKey?: string
}

export async function getRelayAssetInfo({
  chainId,
  address,
  // https://fun-xyz.slack.com/archives/C08MQ85QB2N/p1770674350731879?thread_ts=1770670744.270889&cid=C08MQ85QB2N
  useExternalSearch = true,
  apiKey,
}: GetRelayAssetInfoParams): Promise<RelayTokenInfo> {
  const relayChainId = convertFunToRelayChainId(Number(chainId))
  const relayTokenAddress = convertFunToRelayTokenAddress(
    address as RelayAddress,
    relayChainId,
  )
  const url = `${MAINNET_RELAY_API}/currencies/v2`
  const headers = filterNullishHeaders({
    'Content-Type': 'application/json',
    'x-api-key': apiKey,
  })
  const body = {
    chainIds: [relayChainId],
    address: relayTokenAddress,
    useExternalSearch,
  }
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  })
  if (!response.ok) {
    throw Error(response.statusText)
  }

  const data = await response.json()
  return data?.[0] as RelayTokenInfo
}
